'use strict'

import { Model } from '@vuex-orm/core'

export default class WitnessContact extends Model {
  static get entity () { return 'witnessContacts' }
  static get primaryKey () { return ['willId', 'contactId'] }

  static fields () {
    return {
      willId: this.attr(null),
      contactId: this.attr(null)
    }
  }
}
